import '../../blocks/accordion/accordion.js';

/**
 * Next Level Theme JavaScript
 */

jQuery(document).ready(function($) {

    // Side panel open/close
    $("#menu-toggle").click(function() {
        $("#side-panel").toggleClass("is-open");
        $("#side-panel-overlay").toggleClass("is-visible");
        $(this).toggleClass("is-active");
        $("body").toggleClass("menu-open");
    });

    $("#side-panel-close, #side-panel-overlay").click(function() {
        $("#side-panel").removeClass("is-open");
        $("#side-panel-overlay").removeClass("is-visible");
        $("#menu-toggle").removeClass("is-active");
        $("body").removeClass("menu-open");
        $(".side-panel-submenu-toggle").attr("aria-expanded", "false");
        $(".wp-block-navigation__submenu-container").removeClass("is-expanded").css("max-height", 0);
    });

    $(document).on("keydown", function(e) {
        if (e.key === "Escape") $("#side-panel-close").click();
    });

    // Inject submenu toggle buttons
    $(".side-panel-menu .has-child").each(function() {
        var $item = $(this);
        var label = $item.children(".wp-block-navigation-item__content").text().trim();
        $item.children(".wp-block-navigation-item__content").after(
            '<button class="side-panel-submenu-toggle" type="button" aria-expanded="false" aria-label="Toggle ' + label + ' submenu"><i class="fa-solid fa-chevron-down"></i></button>'
        );
    });

    // Submenu accordion toggle
    $(document).on("click", ".side-panel-submenu-toggle", function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var $btn = $(this);
        var $sub = $btn.siblings(".wp-block-navigation__submenu-container").first();
        var $wpBtn = $btn.siblings(".wp-block-navigation-submenu__toggle").first();
        var open = $btn.attr("aria-expanded") === "true";

        $btn.attr("aria-expanded", open ? "false" : "true");
        if (open) {
            $sub.removeClass("is-expanded").css("max-height", 0);
        } else {
            $sub.addClass("is-expanded").css("max-height", $sub[0].scrollHeight);
        }

        // Sync WP Interactivity API state (works on both 6.9.4 and 7.0)
        if ($wpBtn.length) {
            $wpBtn[0].click();
        }
    });

});
